var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"dr-biz-logo",style:({ height: _vm.height + 'px' }),attrs:{"src":_vm.logoUrl,"alt":"logo"},on:{"click":_vm.goLink}})
}
var staticRenderFns = []

export { render, staticRenderFns }